export default "__VITE_ASSET__BX80hi2J__"